export default __webpack_public_path__ + "static/media/pictogramBeaconSecurity128.01e3094d.svg";